import styled, { ellipsis, MQ_TABLET } from '../../constants/theme'

export const Dialog = styled.div({
  maxWidth: '100%',
  width: 640,
})

export const Header = styled.h1(
  {
    '& p': {
      ...ellipsis,
      paddingRight: 20,
    },
    fontSize: 24,
    minHeight: 80,
  },
  ({ theme }) => ({
    ...MQ_TABLET({
      padding: `0 40px 0 ${theme.padding}px`,
    }),
    alignItems: 'center',
    background: `linear-gradient(315deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
    color: theme.textLight,
    display: 'flex',
    padding: `0 40px 0 ${theme.paddingMobile}px`,
  }),
)

export const Content = styled.div(
  {
    fontSize: 16,
  },
  ({ theme }) => ({
    ...MQ_TABLET({
      padding: theme.padding,
    }),
    backgroundColor: theme.background,
    color: theme.text,
    padding: theme.paddingMobile,
  }),
)

export const Img = styled.img(
  {
    height: 450,
    margin: '0 auto',
    width: 'auto',
  },
  ({ theme }) => ({
    borderRadius: theme.borderRadius,
  }),
)
